import { css } from '@emotion/core'

import { Color } from '../../../enums/color'
import { DefaultValue } from '../../../enums/defaultValue'
import { getDefaultTransition } from '../../../utils/getDefaultTransition'
import { sizeToProps } from '../constants/sizeToProps'
import { InputSize } from '../types/size'

export const getInputStyle = (size: InputSize) => {
  const { fontSize, lineHeight } = sizeToProps[size]

  return css`
    appearance: none;
    outline: none;
    width: 100%;
    border: none;
    padding: 0;
    color: ${Color.Black};
    font-size: ${fontSize};
    font-family: ${DefaultValue.FontFamily};
    line-height: ${lineHeight};
    cursor: inherit;
    ${getDefaultTransition('color')};

    &:focus-visible {
      box-shadow: none;
    }

    &[type='number'] {
      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
        appearance: none;
      }
    }
  `
}
